/**
 * change state of practice question filter
 * @param status
 */
export const changePracticeQuestionFilter = (status) => dispatch => {
    dispatch( {
        type: 'PRACTICE_QUESTION_FILTER_CHANGE',
        payload: status
    });
};